import "./styles.scss";

import { useTranslation } from "react-i18next";
import slugify from "slugify";

import { useFaq } from "context/client/faq";
import useMostSearched from "../../useMostSearched";

import ModalMobile from "components/ModalMobile";
import NeedHelp from "../../../NeedHelp";

import { ReactComponent as ArrowIcon } from "assets/icons/new/forward-arrow.svg";

const mainClass = "faq-most-searched-modal";

const Modal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();

  const { setSelected } = useFaq();
  const { data, shuffledIndices, MAX_ITEMS } = useMostSearched();

  return (
    <ModalMobile
      title={t("FAQ - Frequently Asked Questions")}
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className={mainClass}>
        <div className={`${mainClass}__row`}>
          {shuffledIndices.slice(0, MAX_ITEMS).map((index) => {
            const item = data[index];

            if (!item) return null;

            const slug = item.category.slug;
            const category = {
              label: item.category.title,
              color:
                slug === "payments-and-subscriptions"
                  ? "blue"
                  : slug === "referral-program"
                    ? "green"
                    : "yellow",
            };

            return (
              <div
                key={slugify(item.content.slice(0, 24), {
                  lower: true,
                  strict: true,
                })}
                className={`${mainClass}__item`}
              >
                <h6>{item?.title}</h6>
                <div className={`${mainClass}__item-footer`}>
                  <button
                    type="button"
                    onClick={() =>
                      setSelected({
                        title: item.title,
                        category,
                        content: item.content,
                      })
                    }
                  >
                    {t("See answer")}
                    <i>
                      <ArrowIcon />
                    </i>
                  </button>
                </div>
              </div>
            );
          })}
        </div>
        <div className={`${mainClass}__need-help`}>
          <NeedHelp />
        </div>
      </div>
    </ModalMobile>
  );
};

export default Modal;
